export const flattenData = (data: Record<string, any>, parentKey = '', result: Record<string, any> = {}): Record<string, any> => {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}.${key}` : key;
  
        if (typeof data[key] === 'object' && data[key] !== null && !Array.isArray(data[key])) {
          flattenData(data[key], newKey, result);
        } else {
          result[newKey] = data[key];
        }
      }
    }
    return result;
  };